"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const users_1 = require("@/services/users");
const parseRoles_1 = require("@/useCases/useCaseUtilities/parseRoles");
const users_2 = require("@/store/ducks/users");
const utilities_1 = require("@/utilities");
function listAllEvaluators() {
    return (dispatch) => {
        dispatch((0, users_2.getUsers)());
        (0, users_1.listAllUsers)()
            .then((users) => {
            const mappedUsers = users
                .map((user) => {
                if (typeof user.roles === "string") {
                    user.roles = (0, parseRoles_1.parseRoles)(user.roles);
                }
                user.username = (0, utilities_1.capitalize)(user.username, true);
                return user;
            })
                .sort((a, b) => {
                return a.username.localeCompare(b.username);
            });
            dispatch((0, users_2.getUsersSuccess)(mappedUsers));
        })
            .catch(() => {
            dispatch((0, users_2.getUsersError)());
        });
    };
}
exports.default = listAllEvaluators;
